// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Address_wrapper__1ZKfs","icon":"Address_icon__3cTQ0","protocol":"Address_protocol__13JJR"};